import Interactions from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Interactions';
import { UserRole } from 'api/dtos/user';

type Props = {
    id: string;
    role: UserRole;
    enabled: boolean;
    canTransferOwnership: boolean;
    isActive: boolean;
    onViewDetails?: (id: string) => void;
}

const TeamInteractions = ({
    id, role, enabled, canTransferOwnership, isActive, onViewDetails,
}: Props) => (
    <Interactions
        id={id}
        role={role}
        enabled={enabled}
        canTransferOwnership={canTransferOwnership}
        isActive={isActive}
        onViewDetails={onViewDetails}
    />
);

export default TeamInteractions;
